export const BAC_ACADEMIC_DATA = {
  stages: {
    title: {
      ar: 'الحياة المدرسية',
      fr: 'Vie Scolaire',
      en: 'School Life',
    },
    description: {
      ar: `"" لا يوجد عمل أعظم من منح الأجيال الشابة الأدوات اللازمة لبناء مستقبل أفضل"".
 إميل زولا، كاتب وصحفي فرنسي (1840-1902).`,
      fr: `« Il n’est pas de plus grande œuvre que de donner aux jeunes générations les outils pour forger un avenir meilleur. », Émile Zola, écrivain et journaliste français (1840-1902).`,
      en: `""There is no greater work than providing young generations with the tools to shape a better future.""
 Émile Zola, French writer and journalist (1840-1902).`,
    },
    order: 4,
    attachments: [],
    type: 'academics/stages',
    isArchived: false,
  },
  library: {
    brief: {
      title: {
        ar: 'المكتبة',
        fr: 'Centre de Documentation et d’Information (CDI)',
        en: 'Library',
      },
      description: {
        ar: `جان بول سارتر، فيلسوف وكاتب فرنسي (1905-1980)
   ""القراءة هي السفر؛ والسفر هو القراءة.""`,
        fr: `« Lire, c’est voyager ; voyager, c’est lire. », Jean-Paul Sartre, philosophe et écrivain français (1905-1980).`,
        en: `Jean-Paul Sartre, French philosopher and writer (1905-1980)
   ""Reading is traveling; traveling is reading.""`,
      },
      order: 0,
      attachments: [], //TODO: Attach groupe-livres.jpg
      image: 'groupe-livres.jpg',
      type: 'academics/library',
      isArchived: false,
    },
    frLibrary: {
      title: {
        ar: 'المكتبة الفرنسية',
        fr: 'Le CDI français',
        en: 'The french Library',
      },
      description: {
        ar: `اللائحة الداخلية للمكتبة الفرنسية (C.D.I):
   يمكن للطلاب: 
   • القراءة من أجل المتعة: روايات، شعر، مسرحيات، قصص مصورة، أعمال كلاسيكية، إلخ.
   • القيام بأعمال بحث باستخدام برنامج البحث الوثائقي والمراجع الوثائقية.
   • إنتاج مستندات.
   • إثراء ثقافتهم الشخصية بقراءة مستندات ثقافية.
   • متابعة الأخبار بقراءة الدوريات، الصحف، ولوحات الإعلانات.
   • الاطلاع على المستندات الموجودة واستخدام الأدوات المساعدة: القواميس، الموسوعات الورقية والإلكترونية، الأطالس، الكتب المدرسية.
   • زيارة المركز مع معلم ضمن حصة دراسية.
   • استخدام الحواسيب للكتابة، أو استخدام الإنترنت في إطار البحث الموجه.
   يجب على الطلاب:
   • احترام مسئولي المركز.
   • عدم الدخول بالحقائب وأخذ الأشياء الضرورية للعمل فقط.
   • عدم إحضار المشروبات أو الطعام.
   • التسجيل في سجل الحضور.
   • أن يكونوا هادئين أو يتحدثون بصوت منخفض.
   • الاعتناء بالأثاث والكتب وأدوات المكتبة.
   • احترام ترتيب الكتب لأن لكل كناب مكانه الخاص.
   • الذهاب إلى مسئول المكان لإرجاع أو استعارة كتاب.
   • إعادة ترتيب الكراسي والطاولات قبل المغادرة.
   • الاستئذان قبل استخدام الحواسيب.
   • التسجيل في سجل استخدام الحواسيب.
   • عدم الاطلاع على صناديق البريد، المدونات، مواقع التواصل الاجتماعي أو أي مواقع غير قانونية.
   • عدم الدردشة إلا في إطار المحادثات المدرسية.
   • عدم اللعب على الحواسيب.
   • عدم استخدام الفلاشات.
   • الاستئذان قبل الطباعة.`,
        fr: `Le CDI est un Centre de Documentation et d’Information. 
   Les élèves peuvent
   • Lire pour le plaisir : romans, poésie, pièce de théâtre, Bande Dessinée, œuvres classiques etc.
   - Faire un travail de recherche, en utilisant le logiciel de recherche documentaire et les ouvrages documentaires.
   • Produire des documents.
   • Enrichir leur culture personnelle en lisant des documents de culture.
   • S’informer en lisant les périodiques, la presse et les panneaux d’affichages.
   • Consulter les documents qui s’y trouvent et utiliser les usuels : dictionnaires, encyclopédies papier et électronique, atlas, manuels scolaires.
   • Venir au C.D.I. avec un professeur dans le cadre d’une heure de cours.
   • utiliser les ordinateurs pour consulter les cdroms, mettre en forme du texte (WORD, EXCEL…) et se connecter à Internet dans le cadre des recherches encadrées.
   
   Les élèves doivent
   • Respecter le personnel du CDI et dire bonjour aux enseignantes documentalistes.
   • Déposer les sacs en entrant et ne prendre que les affaires nécessaires au travail.
   • Ne pas amener de boissons ou de nourriture.
   • S’inscrire sur la fiche de présence.
   • Être silencieux ou parler à voix basse.
   • Prendre soin du mobilier, des documents et du matériel.
   • Respecter le classement des documents car tout document a sa place.
   • venir au bureau des enseignantes documentalistes pour rendre ou emprunter un document.
   • Faire un travail qui nécessite l’utilisation de documents du CDI.
   • Ranger chaises et tables avant de quitter le CDI.
   • Demander l’autorisation aux enseignantes documentalistes avant d’utiliser les ordinateurs.
   • S’inscrire sur la fiche d’utilisation des ordinateurs.
   • Ne pas consulter des boîtes aux lettres, des blogs, des sites de société et autres sites illicites.
   • Ne pas chater sauf dans le cadre d’un clavardage scolaire.
   • Ne pas faire des jeux sur les ordinateurs.
   • Ne pas utiliser les clés USB et demander aux enseignantes documentalistes de scanner CD – DVD …. avant de les utiliser.
   • Demander l’autorisation avant toute impression.`,
        en: `Internal Regulations of the french library:
   Students can: 
   • Read for pleasure: novels, poetry, plays, comics, classic works, etc.
   • Conduct research using the documentary search software and reference books.
   • Produce documents.
   • Enrich their personal culture by reading cultural documents.
   • Stay informed by reading periodicals, the press, and bulletin boards.
   • Consult the documents available and use reference materials: dictionaries, paper and electronic encyclopedias, atlases, textbooks.
   • Come to the C.D.I. with a teacher during a class hour.
   • Use computers to access CD-ROMs, format text (WORD, EXCEL…), and connect to the Internet for guided research.
   Students must:
   • Respect the C.D.I. staff and greet the librarian teachers.
   • Leave bags at the entrance and only bring necessary items for work.
   • Not bring drinks or food.
   • Sign the attendance sheet.
   • Remain silent or speak quietly.
   • Take care of the furniture, documents, and equipment.
   • Respect the organization of documents because every document has its designated place.
   • Go to the librarian’s office to return or borrow a document.
   • Do work that requires the use of C.D.I. documents.
   • Arrange chairs and tables before leaving the C.D.I.
   • Ask for permission from the librarian teachers before using the computers.
   • Sign the computer usage log.
   • Not access mailboxes, blogs, social sites, or any illegal websites.
   • Not chat except for school-related messaging.
   • Not play games on the computers.
   • Not use USB.
   • Ask for permission before printing.`,
      },
      order: 0,
      attachments: [], //TODO : Attach CDI FR 2025.png
      image: 'CDI_FR_2025.png',
      type: 'academics/library/fr',
      isArchived: false,
    },
  },
};
